import React, { useState, useRef } from 'react'
import HCaptcha from '@hcaptcha/react-hcaptcha'

const CaptchaWidget = ({ onVerify, onError, onExpire, theme = 'dark', size = 'normal' }) => {
  const [isVisible, setIsVisible] = useState(false)
  const [isVerified, setIsVerified] = useState(false)
  const [token, setToken] = useState(null)
  const captchaRef = useRef(null)

  const sitekey = import.meta.env.VITE_HCAPTCHA_SITEKEY

  if (!sitekey) {
    console.error('VITE_HCAPTCHA_SITEKEY not configured')
    return (
      <div className="text-error text-sm text-center p-4 border border-error/20 rounded-lg">
        Captcha not configured. Please contact support.
      </div>
    )
  }

  const handleVerify = (token) => {
    setIsVerified(true)
    setToken(token)
    onVerify?.(token)
  }

  const handleError = (err) => {
    setIsVerified(false)
    setToken(null)
    onError?.(err)
  }

  const handleExpire = () => {
    setIsVerified(false)
    setToken(null)
    onExpire?.()
  }

  const showCaptcha = () => {
    setIsVisible(true)
  }

  const resetCaptcha = () => {
    setIsVisible(false)
    setIsVerified(false)
    setToken(null)
    captchaRef.current?.resetCaptcha()
  }

  if (!isVisible) {
    return (
      <div className="text-center">
        <button
          onClick={showCaptcha}
          className="btn btn-secondary flex items-center space-x-2 mx-auto"
        >
          <span>🤖</span>
          <span>Verify you're human</span>
        </button>
        <p className="text-text-muted text-xs mt-2">
          Click to show security verification
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {/* Verification status */}
      {isVerified && (
        <div className="flex items-center justify-center space-x-2 text-success text-sm">
          <span>✓</span>
          <span>Verification completed</span>
        </div>
      )}

      {/* Captcha widget */}
      <div className="flex justify-center">
        <div className="transform scale-90 sm:scale-100">
          <HCaptcha
            ref={captchaRef}
            sitekey={sitekey}
            onVerify={handleVerify}
            onError={handleError}
            onExpire={handleExpire}
            theme={theme}
            size={size}
          />
        </div>
      </div>

      {/* Reset button */}
      {(isVerified || token) && (
        <div className="text-center">
          <button
            onClick={resetCaptcha}
            className="text-text-muted hover:text-text-primary text-xs underline"
          >
            Reset verification
          </button>
        </div>
      )}
    </div>
  )
}

export default CaptchaWidget